const API_OBJECT = {
  USERS: {
    GET_ALL: {
      URL: (brandId) => `/api/v1/brands/${brandId}/users/get/all`,
      METHOD: 'GET',
    },
    // Fetches full user details by brandUserId (used for edit pre-population).
    GET_USER: {
      URL: (brandUserId) => `/api/v1/user/${brandUserId}`,
      METHOD: 'GET',
    },
    CREATE_USER_COMPLETE: {
      URL: () => `/api/v2/user/create`,
      METHOD: 'POST',
    },
    UPDATE_USER_COMPLETE: {
      URL: (brandUserId) => `/api/v2/user/${brandUserId}/update`,
      METHOD: 'PUT',
    },
    // Fetches current permissions + brand accesses for a user (used for edit pre-population).
    GET_USER_PERMISSIONS: {
      URL: (brandUserId) => `/api/v1/users/${brandUserId}/permissions`,
      METHOD: 'GET',
    },
    // Fetches the currently assigned role groups for a user.
    GET_USER_ROLE_GROUPS: {
      URL: (brandUserId, brandId) => `/api/v1/users/${brandUserId}/roles/roleGroups/${brandId}`,
      METHOD: 'GET',
    },
    UPDATE_STATUS: {
      URL: (brandUserId, suspended) => `/api/v1/user/${brandUserId}/suspended/${suspended}`,
      METHOD: 'PUT',
    },
    DELETE_USER: {
      URL: (brandUserId) => `/api/v1/user/${brandUserId}`,
      METHOD: 'DELETE',
    },
  },
  PERMISSIONS: {
    GET_ALL: {
      URL: () => `/api/v1/permissions`,
      METHOD: 'GET',
    },
  },
  BRANDS: {
    GET_ALL_WITH_OUTLETS: {
      URL: () => `/api/v1/brands/outlets`,
      METHOD: 'POST',
    },
  },
  ROLE_GROUPS: {
    GET_ALL: {
      URL: (brandId) => `/api/v2/roles/roleGroups/getAll/${brandId}`,
      METHOD: 'GET',
    },
    CREATE: {
      URL: () => `/api/v1/roles/roleGroups`,
      METHOD: 'POST',
    },
    GET_BY_ID: {
      URL: (roleGroupId) => `/api/v1/roles/roleGroups/${roleGroupId}`,
      METHOD: 'GET',
    },
    UPDATE_ROLE_COMPLETE: {
      URL: (roleGroupId) => `/api/v1/roles/roleGroups/${roleGroupId}/updateRole`,
      METHOD: 'PUT',
    },
    UPDATE_STATUS: {
      URL: (roleGroupId) => `/api/v1/roles/roleGroups/${roleGroupId}`,
      METHOD: 'PUT',
    },
    DELETE: {
      URL: (roleGroupId) => `/api/v1/roles/roleGroups/${roleGroupId}`,
      METHOD: 'DELETE',
    },
  },
  CHECK_IS_MFA_ACTIVATED: {
    URL: "/api/v1/mfa/is-activated",
    METHOD: "POST",
  },
  SEND_MFA_SECRET: {
    URL: "/api/v1/mfa/send-secret",
  },
  AUTH: {
    FORGOT_PASSWORD: {
      URL: '/api/v1/forgot-password',
      METHOD: 'POST',
    },
    RESET_PASSWORD: {
      URL: '/api/v1/reset-password',
      METHOD: 'POST',
    },
  },
}

export default API_OBJECT;
